export default "__VITE_ASSET__C8aEIMfG__"